import { render, staticRenderFns } from "./sidebarGroupChatSM.vue?vue&type=template&id=0a0c9c5c&scoped=true"
import script from "./sidebarGroupChatSM.vue?vue&type=script&lang=js"
export * from "./sidebarGroupChatSM.vue?vue&type=script&lang=js"
import style0 from "./sidebarGroupChatSM.vue?vue&type=style&index=0&id=0a0c9c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c9c5c",
  null
  
)

export default component.exports